import { useEffect } from 'react';
import './OraChatBot.scss';

const OraChatBot = (props: any) => {
    // TMP, will remove the title later
    console.log(props);

    useEffect(() => {
        const script1 = document.createElement('script');
        script1.src = 'https://agenticonvo.com/embed/ora-widget.js';

        const script2 = document.createElement('script');
        script2.src = '/ora-chatbot-initiator.js';

        script1.onload = () => {
            console.log('The widget script is loaded, loading the initiator script');
            document.body.appendChild(script2);
        };

        document.body.appendChild(script1);

        return () => {
            script2.remove();
            script1.remove();
        };
    }, []);

    return null;
};

export default OraChatBot;